import { render, staticRenderFns } from "./AccordionItemHtml.vue?vue&type=template&id=082e6e4d"
import script from "./AccordionItemHtml.vue?vue&type=script&lang=js"
export * from "./AccordionItemHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports